import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { bgLinearGradient } from "@/app/types/ui";
import { LanguageSelector } from "@/components/shared/LanguageSelector";
import { MimiatHorizontalLogo } from "@/components/shared/MimiatHorizonalLogo";
import { HeadingOne } from "@/components/ui/typography/HeadingOne";
import { ParagraphBold } from "@/components/ui/typography/ParagraphBold";
import { Paragraph } from "@/components/ui/typography/Paragraph";
import { RegisterClinicDataForm } from "@/components/register/beta/RegisterClinicDataForm";

import loginImg from "@/assets/login/login-img.png";

export const Route = createFileRoute("/register/beta/clinic")({
  component: ClinicData,
});

function ClinicData() {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-5 min-h-screen max-h-screen overflow-y-hidden">
      {/* Image */}
      <div className="grid col-span-2 bg-beige self-center overflow-y-hidden">
        <img src={loginImg} alt="Login img" />
      </div>

      {/* Clinic Data Form */}
      <div
        className={`grid col-span-3 ${bgLinearGradient} border-l-1 border-neutral-500 overflow-y-auto max-h-screen [&::-webkit-scrollbar]:w-1 [&::-webkit-scrollbar-track]:rounded-full [&::-webkit-scrollbar-track]:bg-beige [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-thumb]:bg-neutral-100`}
      >
        <div>
          <div className="my-8 flex justify-end mx-24 2xl:max-w-3xl 2xl:mx-auto">
            <LanguageSelector />
          </div>
          <div className="flex flex-col my-auto mt-4 justify-center">
            <div className="mx-auto mb-8">
              <MimiatHorizontalLogo />
            </div>
            <div className="mx-24 2xl:min-w-[575px] 2xl:max-w-[609px] 2xl:mx-auto mb-12">
              <div className="flex flex-col gap-2 mb-4">
                <div className="flex gap-3 items-baseline">
                  <HeadingOne>{t("register.clinic.title")} </HeadingOne>
                  <ParagraphBold>{t("register.clinic.step")}</ParagraphBold>
                </div>
                <Paragraph>{t("register.clinic.subtitle")}</Paragraph>
              </div>
              <RegisterClinicDataForm />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
